import { FaAlignLeft, FaAlignCenter, FaAlignRight, FaTrashAlt } from 'react-icons/fa';
import styles from './styles.module.css';

interface ImageBlockToolbarProps {
  align: 'left' | 'center' | 'right' | null;
  float: 'left' | 'right' | null;
  onAlignChange: (value: 'left' | 'center' | 'right') => void;
  onFloatChange: (value: 'left' | 'right') => void;
  onDelete: () => void;
  flipped: boolean;
}

// Imagem flutuando à direita, texto à esquerda contornando.
function IconWrapTextLeft() {
  return (
    <svg width="14" height="14" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="9" y="2" width="5" height="5" fill="currentColor" />
      <line x1="2" y1="3" x2="7.5" y2="3" stroke="currentColor" strokeWidth="1" />
      <line x1="2" y1="5.5" x2="7.5" y2="5.5" stroke="currentColor" strokeWidth="1" />
      <line x1="2" y1="8" x2="14" y2="8" stroke="currentColor" strokeWidth="1" />
      <line x1="2" y1="10.5" x2="14" y2="10.5" stroke="currentColor" strokeWidth="1" />
      <line x1="2" y1="13" x2="14" y2="13" stroke="currentColor" strokeWidth="1" />
    </svg>
  );
}

// Imagem flutuando à esquerda, texto à direita contornando.
function IconWrapTextRight() {
  return (
    <svg width="14" height="14" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="2" y="2" width="5" height="5" fill="currentColor" />
      <line x1="8.5" y1="3" x2="14" y2="3" stroke="currentColor" strokeWidth="1" />
      <line x1="8.5" y1="5.5" x2="14" y2="5.5" stroke="currentColor" strokeWidth="1" />
      <line x1="2" y1="8" x2="14" y2="8" stroke="currentColor" strokeWidth="1" />
      <line x1="2" y1="10.5" x2="14" y2="10.5" stroke="currentColor" strokeWidth="1" />
      <line x1="2" y1="13" x2="14" y2="13" stroke="currentColor" strokeWidth="1" />
    </svg>
  );
}

export function ImageBlockToolbar({
  align,
  float,
  onAlignChange,
  onFloatChange,
  onDelete,
  flipped,
}: ImageBlockToolbarProps) {
  const buttons: {
    title: string;
    icon: React.ReactNode;
    active: boolean;
    onClick: () => void;
  }[] = [
    {
      title: 'Alinhar à esquerda',
      icon: <FaAlignLeft />,
      active: align === 'left',
      onClick: () => onAlignChange('left'),
    },
    {
      title: 'Centralizar',
      icon: <FaAlignCenter />,
      active: align === 'center',
      onClick: () => onAlignChange('center'),
    },
    {
      title: 'Alinhar à direita',
      icon: <FaAlignRight />,
      active: align === 'right',
      onClick: () => onAlignChange('right'),
    },
    {
      title: 'Texto à esquerda da imagem',
      icon: <IconWrapTextLeft />,
      active: float === 'right',
      onClick: () => onFloatChange('right'),
    },
    {
      title: 'Texto à direita da imagem',
      icon: <IconWrapTextRight />,
      active: float === 'left',
      onClick: () => onFloatChange('left'),
    },
  ];

  return (
    <div
      className={`${styles.toolbar} ${flipped ? styles.toolbarFlipped : ''}`}
      contentEditable={false}
      onMouseDown={(e) => e.preventDefault()}
    >
      {buttons.map((b, i) => (
        <button
          key={i}
          type="button"
          title={b.title}
          className={`${styles.toolbarButton} ${b.active ? styles.toolbarButtonActive : ''}`}
          onClick={b.onClick}
        >
          {b.icon}
        </button>
      ))}
      <span className={styles.toolbarSeparator} />
      <button
        type="button"
        title="Excluir imagem"
        className={`${styles.toolbarButton} ${styles.toolbarButtonDanger}`}
        onClick={onDelete}
      >
        <FaTrashAlt />
      </button>
    </div>
  );
}
